import { InductionSlideType } from "../models/InductionSlides";
import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getSlide(id?: string) {
  try {
    const response = await apiGet("core", `induction-page/${id}`);
    return response.content;
  } catch (e) {
    return {};
  }
}

export async function addInductionSlide(newDetails: InductionSlideType) {
  const response = await apiPost("core", `induction-page`, newDetails);
  return response?.content;
}
//
// export async function submitInductionSlide(newDetails: any) {
//     const response = await apiPost('core', `induction_result`, newDetails);
//     return response?.content;
// }

export async function updateInductionSlide(
  id: string,
  newDetails: InductionSlideType,
) {
  const response = await apiPut("core", `induction-page/${id}`, newDetails);

  return response?.content;
}

export async function removeInductionSlide(id: any) {
  return await apiDelete("core", `induction-page/${id}`);
}
